export default __webpack_public_path__ + "static/media/vegetationImg.affd44cf.png";